import { useWizard } from '../../context/WizardContext';
import { motion } from 'framer-motion';
import { MapPin, Globe, Plane, Briefcase, GraduationCap, FileCheck, Users, Building2, Heart, RefreshCw, Shield as ShieldIcon } from 'lucide-react';

const destinationCountries = [
  { value: 'Estados Unidos', label: 'Estados Unidos', flag: 'us' },
  { value: 'Portugal', label: 'Portugal', flag: 'pt' },
  { value: 'Espanha', label: 'Espanha', flag: 'es' },
  { value: 'Canada', label: 'Canada', flag: 'ca' },
  { value: 'Italia', label: 'Italia', flag: 'it' },
  { value: 'Alemanha', label: 'Alemanha', flag: 'de' },
  { value: 'Australia', label: 'Australia', flag: 'au' },
  { value: 'Japao', label: 'Japao', flag: 'jp' },
  { value: 'Reino Unido', label: 'Reino Unido', flag: 'gb' },
  { value: 'Franca', label: 'Franca', flag: 'fr' },
];

const nationalities = [
  { value: 'Brasil', label: 'Brasil' },
  { value: 'Portugal', label: 'Portugal' },
  { value: 'Argentina', label: 'Argentina' },
  { value: 'Colombia', label: 'Colombia' },
  { value: 'Mexico', label: 'Mexico' },
  { value: 'Venezuela', label: 'Venezuela' },
  { value: 'Chile', label: 'Chile' },
  { value: 'Peru', label: 'Peru' },
  { value: 'Equador', label: 'Equador' },
  { value: 'Outro', label: 'Outro' }
];

const goals = [
  { value: 'trabalho', label: 'Trabalhar', icon: Briefcase },
  { value: 'estudo', label: 'Estudar', icon: GraduationCap },
  { value: 'residencia', label: 'Residencia', icon: FileCheck },
  { value: 'reagrupamento', label: 'Reagrupamento', icon: Users },
  { value: 'empreender', label: 'Empreender', icon: Building2 },
  { value: 'turismo_longa', label: 'Nomade Digital', icon: Heart },
  { value: 'renovar', label: 'Renovar Docs', icon: RefreshCw },
  { value: 'protecao', label: 'Asilo', icon: ShieldIcon },
];

export const Step1DestinoObjetivo = () => {
  const { data, updateData, nextStep } = useWizard();

  const handleDestinationSelect = (country) => {
    updateData({
      destination_country: country,
      inside_spain: country === 'Espanha',
      inside_eu: ['Espanha', 'Portugal', 'Italia', 'Franca', 'Alemanha'].includes(country)
    });
  };

  const isValid = data.destination_country && data.nationality && data.goal;

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="space-y-5"
    >
      {/* Destination */}
      <div>
        <label className="block text-sm text-gray-400 mb-2">
          <Plane className="inline w-4 h-4 mr-1 text-[#C9A24A]" />
          Para qual pais deseja emigrar?
        </label>
        <div className="grid grid-cols-2 gap-2">
          {destinationCountries.map((country) => (
            <button
              key={country.value}
              type="button"
              data-testid={`dest-${country.flag}`}
              onClick={() => handleDestinationSelect(country.value)}
              className={`p-2.5 rounded-lg border text-left transition-colors flex items-center gap-2 ${
                data.destination_country === country.value
                  ? 'bg-[#C9A24A]/20 border-[#C9A24A] text-[#C9A24A]'
                  : 'bg-white/5 border-white/10 text-gray-300 hover:border-[#C9A24A]/50'
              }`}
            >
              <img src={`https://flagcdn.com/w40/${country.flag}.png`} alt={country.label} className="w-6 h-auto rounded shadow-sm" />
              <span className="text-sm">{country.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Nationality */}
      <div>
        <label className="block text-sm text-gray-400 mb-2">
          <Globe className="inline w-4 h-4 mr-1 text-[#C9A24A]" />
          Sua nacionalidade
        </label>
        <select
          data-testid="nationality-select"
          value={data.nationality}
          onChange={(e) => updateData({ nationality: e.target.value, country_now: e.target.value })}
          className="w-full input-dark"
        >
          <option value="">Selecione</option>
          {nationalities.map((n) => (
            <option key={n.value} value={n.value}>{n.label}</option>
          ))}
        </select>
      </div>

      {/* Goal */}
      <div>
        <label className="block text-sm text-gray-400 mb-2">
          Qual seu objetivo principal?
        </label>
        <div className="grid grid-cols-2 gap-2">
          {goals.map((goal) => {
            const Icon = goal.icon;
            return (
              <button
                key={goal.value}
                type="button"
                data-testid={`goal-${goal.value}`}
                onClick={() => updateData({ goal: goal.value })}
                className={`p-2.5 rounded-lg border text-left transition-colors flex items-center gap-2 ${
                  data.goal === goal.value
                    ? 'bg-[#C9A24A]/20 border-[#C9A24A] text-[#C9A24A]'
                    : 'bg-white/5 border-white/10 text-gray-300 hover:border-[#C9A24A]/50'
                }`}
              >
                <Icon className={`w-4 h-4 ${data.goal === goal.value ? 'text-[#C9A24A]' : 'text-gray-500'}`} />
                <span className="text-sm">{goal.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      <div className="pt-2">
        <button
          type="button"
          data-testid="step1-next"
          onClick={nextStep}
          disabled={!isValid}
          className={`w-full btn-gold ${!isValid ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          Continuar
        </button>
      </div>
    </motion.div>
  );
};

export default Step1DestinoObjetivo;
